<template>
  <div id="app">
    <transition name="fade">
    <div v-if="!preloading">
      <Navbar :school="school" :changeSchooll="changeSchooll"/>
        <div class='con'>
    <transition name="fade">
        <router-view :school="school">
        </router-view>
    </transition>
          </div>
      <Footer/>
    </div>
    <div v-else class="loading">
      <div v-show="preloading" class="Loading">
        <Loading :preloading="preloading" :stopLoading="stopLoading" :changeSchooll="changeSchooll"/>
      </div>
    </div>
    </transition>
  </div>
</template>

<script>
import Navbar from './components/Nav'
import Footer from './components/Foot'
import Loading from './components/pages/Loading'
export default {
  name: 'App',
  data: function () {
    return {
      preloading: true,
      stjustins: true,
      school: 'stgregs'
    }
  },
  mounted: function () {
    // setTimeout(() => {
    //   this.preloading = false
    // }, 500)
  },
  components: { Navbar, Footer, Loading },
  methods: {
    changeSchooll: function (value) {
      this.school = value
    },
    stopLoading: function () {
      this.preloading = false
    }
  }
}
</script>

<style scoped>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /* color: #2c3e50; */
  color: #111;
  background: #fff;
    /* background: #dd5293; */
  min-width: 100vw;
  min-height: calc(100vh - 60px);
}
.right {
  float: right;
}
a {
  color: #e67e22;
}
.footer {
  padding: 5em 0em;
  text-align: left;
}
.left {
  text-align: left;
}

/* Enter and leave animations can use different */
/* durations and timing functions.              */
.slide-fade-enter-active {
  transition: all .3s ease;
}
.slide-fade-leave-active {
  transition: all .8s cubic-bezier(1.0, 0.5, 0.8, 1.0);
}
.slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.fade-enter-active, .fade-leave-active {
  transition-property: opacity;
  transition-duration: .75s;
}

.fade-enter-active {
  transition-delay: .75s;
}

.fade-enter, .fade-leave-active {
  opacity: 0
}
.con {
  min-height: calc(100vh - 60px - 184px);
  margin-top: 60px;
}
[v-cloak] {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/App.vue